import BaseApiService from './baseApiService';

export default class NewsService extends BaseApiService {
  static async getNewsURI(): Promise<{ uri: string }> {
    return (await super.get<{ uri: string }>('news/uri')).getData();
  }
}
